'use client';

import React from 'react';
import { Beaker, LogIn, Leaf } from 'lucide-react';

interface MobileBottomNavProps {
  onNavigate: (section: 'ingredients' | 'chemist' | 'partner') => void;
  activeSection?: string;
}

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ onNavigate, activeSection }) => {
  const navItems = [
    {
      id: 'ingredients',
      label: 'Ingredients',
      icon: Leaf,
      onClick: () => onNavigate('ingredients')
    },
    {
      id: 'chemist',
      label: 'Chemist',
      icon: Beaker,
      onClick: () => onNavigate('chemist')
    },
    {
      id: 'partner',
      label: 'Portal',
      icon: LogIn,
      onClick: () => onNavigate('partner')
    }
  ];

  return (
    <nav className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[100] sm:hidden w-[80%]">
      {/* ✅ OPTIMIZED: Removed backdrop-blur-xl (GPU-intensive), simplified styling */}
      <div className="flex items-center justify-around p-1.5 bg-gray-900/90 border border-white/10 rounded-full shadow-lg">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeSection === item.id;

          return (
            <button
              key={item.id}
              onClick={item.onClick}
              className={`
                flex flex-col items-center justify-center gap-1 px-4 py-2
                transition-colors duration-200 rounded-full
                ${isActive
                  ? 'text-blue-400 bg-blue-500/10'
                  : 'text-white/60 active:text-white'
                }
              `}
              aria-label={item.label}
            >
              <Icon
                size={24}
                className={isActive ? 'scale-110' : 'scale-100'}
              />
              <span className="text-[10px] font-medium">
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;